export const mockData = {
  personal: {
    name: 'Md Katif Ahmad',
    tagline: 'Specialized in Application Security , Network Security , Cloud Security',
    bio: 'Passionate cybersecurity professional with expertise in offensive security, penetration testing, and security analysis. Focused on making digital systems more secure through ethical hacking and comprehensive security assessments.',
    location: 'Global Remote',
    stats: [
      { label: 'Years Experience', value: '3' },
      { label: 'Projects', value: '4+' },
      { label: 'Certifications', value: '5+' },
      { label: 'Security Tools', value: '2' }
    ]
  },
  
  skills: {
    categories: [
      {
        name: 'Security Testing',
        icon: 'Shield',
        color: 'green',
        skills: [
          { name: 'Web application security', level: 95 },
          { name: 'Network security', level: 90 },
          { name: 'API security', level: 85 },
          { name: 'Active directory security', level: 80 },
          { name: 'Cloud security', level: 85 },
          { name: 'Android Security', level: 85 },
          
        ]
      },
      {
        name: 'Programming',
        icon: 'Code',
        color: 'yellow',
        skills: [
          { name: 'Python (Pentesting)', level: 90 },
          { name: 'Bash Scripting', level: 85 },
          { name: 'PowerShell', level: 75 },
          { name: 'JavaScript', level: 80 },
          { name: 'SQL', level: 85 }
        ]
      },
      
      {
        name: 'Security Tools',
        icon: 'Wrench',
        color: 'red',
        skills: [
          { name: 'Burp Suite', level: 95 },
          { name: 'Wireshark', level: 90 },
          { name: 'Nessus', level: 85 },
          { name: 'Metasploit', level: 88 },
          { name: 'OWASP ZAP', level: 85 },
          { name: 'SQLmap', level: 92 },
          { name: 'nmap', level: 85 },
          { name: 'John the Ripper', level: 80 },
          { name: 'Professional tools', level: 90 },
          { name: 'Other Open Source', level: 90 },
          { name: 'Customize', level: 88 },
          
        ]
      },
     {
        name: 'Malware analyst',
        icon: 'Smartphone',
        color: 'cyan',
        skills: [
          { name: 'SIEM Analysis', level: 95 },
          { name: ' Log analysis', level: 80 },
          { name: 'Mobile Malware Analysis', level: 85 },
          { name: 'Incident and Forensics', level: 90 }
        ]
      },
      {
        name: 'Digital Forensics',
        icon: 'Search',
        color: 'purple',
        skills: [
          { name: 'File System Analysis', level: 90 },
          { name: 'Memory Forensics', level: 85 },
          { name: 'Network Forensics', level: 80 },
          { name: 'Malware Analysis', level: 88 },
          { name: 'Incident Response', level: 85 }
        ]
      }
    ]
  },

  projects: {
    featured: [
      {
        id: 1,
        title: 'statix',
        description: 'Statix is a Python-based static analysis tool designed for security researchers and malware analysts. It helps in quickly gathering insights from binary files by    extracting hashes, strings, entropy, suspicious imports and functions',
        image: 'https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=800&h=600&fit=crop',
        technologies: ['Python', 'Terminal', 'pwn', 'programming'],
        category: 'Security Tool',
        status: 'Live',
        githubUrl: 'https://github.com/katifsec/statix',
        demoUrl: null,
        highlights: [
          'Multiple app schemes support',
          'Terminal-based interface',
          'Fast and reliable conversion',
          'Open source security tool'
        ]
      },
      {
        id: 2,
        title: 'MOF (File Forensics Tool)',
        description: 'Advanced file forensic and metadata analysis tool for digital investigations and security assessments.',
        image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&h=600&fit=crop',
        technologies: ['Python', 'Digital Forensics', 'Metadata Analysis', 'Security'],
        category: 'Forensics Tool',
        status: 'Live',
        githubUrl: 'https://github.com/katifsec/mof',
        demoUrl: null,
        highlights: [
          'Comprehensive metadata extraction',
          'File system analysis capabilities',
          'Evidence preservation features',
          'Forensic investigation support'
        ]
      },
      {
        id: 3,
        title: 'Android APK Security Scanner',
        description: 'Automated security analysis tool for Android applications, identifying vulnerabilities and security misconfigurations.',
        image: 'https://images.unsplash.com/photo-1551650975-87deedd944c3?w=800&h=600&fit=crop',
        technologies: ['Python', 'Android Security', 'APK Analysis', 'Automation'],
        category: 'Mobile Security',
        status: 'Development',
        githubUrl: null,
        demoUrl: null,
        highlights: [
          'Automated vulnerability detection',
          'Comprehensive security checks',
          'Detailed reporting system',
          'Batch processing capabilities'
        ]
      }
    ]
  },

  certifications: [
    {
      id: 1,
      title: 'Certified Ethical Hacker ',
      issuer: 'Cisco',
      date: '2024',
      image: 'https://images.unsplash.com/photo-1614064641938-3bbee52942c7?w=400&h=300&fit=crop',
      description: 'Comprehensive ethical hacking certification covering various security domains.',
      skills: ['Ethical Hacking', 'Penetration Testing', 'Security Analysis', 'Vulnerability Assessment']
    },
    {
      id: 2,
      title: 'Certified DFIR',
      issuer: 'BlackPerl',
      date: '2025',
      image: 'https://images.unsplash.com/photo-1580894894513-541e068a3e2b?w=400&h=300&fit=crop',
      description: 'Practical penetration testing certification with hands-on experience.',
      skills: ['Memory Forensics','Incident Response','Practical Security']
    },
     {
      id: 3,
      title: 'Malware Analyst',
      issuer: 'BlackPerl',
      date: '2025',
      image: 'https://images.unsplash.com/photo-1580894894513-541e068a3e2b?w=400&h=300&fit=crop',
      description: 'Practical penetration testing certification with hands-on experience.',
      skills: ['Malware analysis','Reverse Engineering', 'Practical Security']
    },
    {
      id: 4,
      title: 'TryHackMe Certified Penetration Tester',
      issuer: 'TryHackMe',
      date: '2024',
      image: 'https://images.unsplash.com/photo-1580894894513-541e068a3e2b?w=400&h=300&fit=crop',
      description: 'Practical penetration testing certification with hands-on experience.',
      skills: ['Penetration Testing', 'Red Teaming', 'CTF Challenges', 'Practical Security']
    },
    {
      id: 5,
      title: 'Top 100 - Great AppSec Hackathon 2024',
      issuer: 'Application Security Event',
      date: '2024',
      credentialId: 'GASH-2024-TOP100',
      image: 'https://images.unsplash.com/photo-1587440871875-191322ee64b0?w=400&h=300&fit=crop',
      description: 'Achieved top 100 ranking in premier application security competition.',
      skills: ['Application Security', 'Competitive Hacking', 'Web Security', 'Bug Bounty']
    },
    {
      id: 6,
      title: 'CTF Champion - Cyberwarfare Junior SE',
      issuer: 'Cyberwarfare',
      date: '2024',
      image: 'https://images.unsplash.com/photo-1516110833967-0b5ee0d87a9b?w=400&h=300&fit=crop',
      description: 'Successfully completed CTF challenges for Junior Security Engineer position.',
      skills: ['CTF Challenges', 'Problem Solving', 'Security Engineering', 'Team Collaboration']
    }
  ],

  about: {
    title: 'About Me',
    content: [
      'I am a passionate Offensive Security Engineer with expertise in penetration testing, security analysis, and digital forensics. My journey in cybersecurity began with a fascination for understanding how systems work and finding ways to make them more secure.',
      'With certifications from EC-Council and TryHackMe, I have demonstrated proficiency in ethical hacking and penetration testing methodologies. My achievement of reaching the top 100 in the 2024 Great AppSec Hackathon showcases my practical skills in application security.',
      'I specialize in Android APK security analysis, web application security testing, and digital forensics. My tools KatifEnc and MOF reflect my commitment to developing practical security solutions for the community.',
      'When I am not breaking into systems ethically, I enjoy participating in CTF competitions, contributing to open-source security projects, and staying updated with the latest security trends and techniques.'
    ],
    funFact: 'Hacking is not just about breaking things. It is about knowing how things work and making them better! 🕵️‍♂️'
  },

  contact: {
    email: 'adilwarshi@.com',
    linkedin: 'https://www.linkedin.com/in/katif-ahmad-574193265/',
    github: 'https://github.com/katifsec',
    twitter: 'https://twitter.com/katifsec',
    availability: 'Open for freelance security assessments and consulting'
  }
};
